/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Featured_MinInputs */

const en_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("en", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} min`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} mins`);
	return /** @type {LocalizedString} */ (`${i?.number} mins`)
	
};

const ar_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ar", i?.number, {});
	if (numberPlural == "zero") return /** @type {LocalizedString} */ (`${i?.number} دقيقة`);
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} دقيقة`);
	if (numberPlural == "two") return /** @type {LocalizedString} */ (`${i?.number} دقيقتان`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`${i?.number} دقائق`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`${i?.number} دقيقةً`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} دقيقة`);
	return /** @type {LocalizedString} */ (`${i?.number} دقيقة`)
	
};

const de_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("de", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} Min.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} Min.`);
	return /** @type {LocalizedString} */ (`${i?.number} Min.`)
	
};

const es_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("es", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} min`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} min`);
	return /** @type {LocalizedString} */ (`${i?.number} min`)
	
};

const fr_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("fr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} min`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} min`);
	return /** @type {LocalizedString} */ (`${i?.number} min`)
	
};

const it_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("it", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} min`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} min`);
	return /** @type {LocalizedString} */ (`${i?.number} min`)
	
};

const ja_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ja", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}分`);
	return /** @type {LocalizedString} */ (`${i?.number}分`)
	
};

const ko_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ko", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}분`);
	return /** @type {LocalizedString} */ (`${i?.number}분`)
	
};

const pt_br_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("pt_br", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} min`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} min`);
	return /** @type {LocalizedString} */ (`${i?.number} min`)
	
};

const ru_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ru", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} мин.`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`${i?.number} мин.`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`${i?.number} мин.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} мин.`);
	return /** @type {LocalizedString} */ (`${i?.number} мин.`)
	
};

const th_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("th", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} นาที`);
	return /** @type {LocalizedString} */ (`${i?.number} นาที`)
	
};

const tr_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("tr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} dk.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} dk.`);
	return /** @type {LocalizedString} */ (`${i?.number} dk.`)
	
};

const zh_cn_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_cn", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 分钟`);
	return /** @type {LocalizedString} */ (`${i?.number} 分钟`)
	
};

const zh_tw_featured_min = /** @type {(inputs: Featured_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_tw", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 分鐘`);
	return /** @type {LocalizedString} */ (`${i?.number} 分鐘`)
	
};

/**
* | numberPlural | output |
* | --- | --- |
* | "one" | "{number} min" |
* | "other" | "{number} mins" |
* | * | "{number} mins" |
*
* @param {Featured_MinInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const featured_min = /** @type {((inputs: Featured_MinInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_MinInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featured_min(inputs)
	if (locale === "ar") return ar_featured_min(inputs)
	if (locale === "de") return de_featured_min(inputs)
	if (locale === "es") return es_featured_min(inputs)
	if (locale === "fr") return fr_featured_min(inputs)
	if (locale === "it") return it_featured_min(inputs)
	if (locale === "ja") return ja_featured_min(inputs)
	if (locale === "ko") return ko_featured_min(inputs)
	if (locale === "pt_br") return pt_br_featured_min(inputs)
	if (locale === "ru") return ru_featured_min(inputs)
	if (locale === "th") return th_featured_min(inputs)
	if (locale === "tr") return tr_featured_min(inputs)
	if (locale === "zh_cn") return zh_cn_featured_min(inputs)
	return zh_tw_featured_min(inputs)
});